import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "../../constants/env";

export function formatDate(date?: string | Date, dateFormat: string = DEFAULT_DATE_FORMAT): string | null {
  if (!date) return null;

  const isValid = moment(date).isValid();

  return isValid ? moment(date).format(dateFormat) : null;
}

export function toUnixTimestamp(date?: string | Date): string | undefined {
  if (!date) {
    return undefined;
  }

  const momentDate = moment(date);

  if (!momentDate.isValid()) {
    return undefined;
  }

  return momentDate.unix().toString();
}
